<template>
    <div>
        <div v-if="delete_loader" class="checkoutLoader">
            <div class="d-flex align-items-center justify-content-center bg-white h-100" style="height: 100vh !important;">
                <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-between mb-3">
            <ul class="d-flex align-items-center pl-4 mb-0">
                <li class="d-flex align-items-center employee_list_active">
                    <span class="list-text fs-16 highlighted">Report Generation Schedule</span>
                </li>
            </ul>
            <button class="btn btn-create btn-smm "
                @click="CreateReportScheduleModal">
                <i class="icon icon-plus-circle create-icon  fs-20"></i>
                <span class="ml-1 fs-14 " style="color: #388e3c;"> New </span>
            </button>
        </div>
        <div>
            <div class="py-3 position-content-main mt-4"
                style="height: auto !important;background: #f0ddb7!important; border-radius: 10px;">
                <div class="page-layout blank">
                    <div class="pb-2" style="min-height:fit-content;">
                        <div class="d-flex flex-wrap justify-content-between" style="gap:1rem">
                            <div class="breadcrumbnewtheme pb-3">

                                <div class="pre gap-0p5 fw-500 text-capitalize">
                                    Report Generated Schedule
                                </div>
                                <span style="color:#b2bec3">/</span>
                                <span class="curr gap-0p5 fw-500">
                                    List View
                                </span>
                            </div>
                            <div class="d-flex align-items-center justify-content-between mb-4" style="gap:.5rem">
                                <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                                    <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                        <!-- <i class="icon-chevron-double-left"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left.svg" style=" z-index: 10">
                                    </el-tooltip>
                                </button>
                                <button @click="previousPage()" :disabled="skip == 0"
                                    class="pagination-list-single mt-1 ml-2 pointer">
                                    <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                        <!-- <i class="icon icon-chevron-left"></i> -->
                            <img src="/static/images/new-theme2024/arrow-left-single.svg" style=" z-index: 10">
                                    </el-tooltip>
                                </button>
                                <span class="px-2 fw-500 fs-14 mt-1 text-black">Showing {{getSkipCount}} -
                                    {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                                <button @click="nextPage()" :disabled="skip_temp >= total"
                                    class="pagination-list-single mt-1 mr-2 pointer">
                                    <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                        <!-- <i class="icon icon-chevron-right"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right-single.svg" style=" z-index: 10">

                                    </el-tooltip>
                                </button>
                                <button @click="lastPage()" class="mt-1 pointer pagination-list"
                                    :disabled="temp_total == total">
                                    <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                        <!-- <i class="icon-chevron-double-right"></i> -->
                            <img src="/static/images/new-theme2024/arrow-right.svg" style=" z-index: 10">

                                    </el-tooltip>
                                </button>
                            </div>
                        </div>
                        <div class="vendor-list height-fit-content" style="background-color: #f6f8fc !important;">
                            <div class="p-0">
                                <!-- <div v-if="ajax_call_in_progress">
                                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center"/>
                            </div> -->
                                <div>
                                    <div class="row" style="background: #f0ddb7;">
                                        <div class="col-lg-4 col-md-4 col-sm-6 left-list" style="margin-right: -10px;">
                                            <div class="mb-3 scroll-new view-box">
                                                <div v-if="ajax_call_in_progress"
                                                    class="d-flex align-items-center justify-content-center bg-white h-100" style="height: 100vh !important;">
                                                    <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                                                </div>
                                                <div v-else-if="list_data.length == 0"
                                                    class="d-flex align-items-center fw-600 fs-15 justify-content-center bg-white h-100" style="height: 100vh !important;">
                                                    No Data Found
                                                </div>
                                                <div v-else v-for="(data, index) in list_data" :key="index+'list_data'">
                                                    <div class="list-box px-4 py-2 pointer"
                                                        :class="{ 'list-light': index % 2, 'highlight': selected_id == data._id }"
                                                        @click="fetchDataById(data._id)">
                                                        <div class="d-flex flex-wrap justify-content-between">
                                                            <span class="fs-14 font-weight-bold text-black">Schedule
                                                                Name: {{data.schedule_name || '-'}}</span>
                                                        </div>
                                                        <div class="d-flex flex-wrap justify-content-between mt-2">
                                                            <span class="text-black fw-600"
                                                                style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
                                                                :title="data.schedule_time">
                                                                Schedule Time:
                                                                {{data.schedule_time.replace(/_/g, ' ') || '-'}}</span>
                                                        </div>
                                                        <div class="d-flex justify-content-between mt-2">
                                                            <span class="text-black fw-500 "
                                                                style="width: 175px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "
                                                                :title="data.shiftwise">Shift:
                                                                {{data.shiftwise || "-"}} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8 col-md-8 col-sm-6 details-view-box scroll-new"
                                            style="overflow-y: auto !important;height: 420px !important; background-color: white !important;">
                                            <div class="page-layout blank contacts-manage pt-3"
                                                style="margin-left: 0px !important;margin-right: 0px !important;">
                                                <div class="pb-10">
                                                    <div class="vendor-list br-t-l-r mt-2" id="printId">
                                                        <div class="d-flex align-items-center justify-content-center" v-if=" ajax_call_in_progress" style="height: 100vh !important;">
                                                            <img class="mt-5 mb-5" src="/static/images/new-theme2024/20 card.gif" width="100" alt="digi-loader">
                                                        </div>
                                                        <div v-else-if="list_data.length == 0" class="d-flex align-items-center fw-600 fs-15 justify-content-center bg-white h-100" style="height: 100vh !important;">
                                                            No Data Selected
                                                        </div>
                                                        <div class="mb-3" v-else>
                                                            <div
                                                                class=" d-flex align-items-center justify-content-between  ">
                                                                <div>
                                                                    <span class=" font-weight-bold pl-1 black-border-bottom">
                                                                        {{ schedule_name || '-' }} Details</span>
                                                                </div>
                                                                <div>
                                                                    <button class="edit-button-new pointer"
                                                                        @click="showEditModal()">
                                                                        <i
                                                                            class="icon ri-pencil-line fs-20 text-white icon-custom-style item"></i></button>
                                                                    <button class="edit-button pointer ml-2"
                                                                        style="background-color: #ef3c36; border-radius: 4px;"
                                                                        @click="deleteScheduleConfirm()">
                                                                        <i
                                                                            class="icon ri-delete-bin-4-fill fs-20 text-white  icon-custom-style item"></i></button>
                                                                </div>
                                                            </div>
                                                            <div class=" header-detail-view-new mt-5 p-3">
                                                                <div>
                                                                    <span class="pl-1 ">Details of the Report
                                                                        Generation</span>
                                                                </div>
                                                            </div>
                                                            <div class="row m-0 mt-3">
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-6 fw-500">Schedule Name:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black fw-500">
                                                                            {{ schedule_name || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-8 fw-500">Schedule Time:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black fw-500">
                                                                            {{ schedule_time || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-26 fw-500">Shift: </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black fw-500">
                                                                            {{ shift_name.shift_name || '-' }} </p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-20 fw-500 text-nowrap-custom">Email ID:</p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black fw-500">
                                                                            {{ email_ids || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-6 col-sm-12 d-flex mb-2">
                                                                    <div>
                                                                        <p class="text-black pr-14 fw-500">Description:
                                                                        </p>
                                                                    </div>
                                                                    <div>
                                                                        <p class="text-black fw-500 description-text-custom">{{ description || '-' }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <add-new-report-schedule v-if="addreportmodal" :mode="mode" @saveSuccess="saveSuccess"
            :report_schedule_id="selected_id" @hide-add-new-schedule="HideAddScheduleModal"
            modal_name="CreateNewReportModal"></add-new-report-schedule>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import facility_mgmt from '../../mixins/facility_mgmt';
    const AddNewReportSchedule = () => import('./AddNewReportSchedule');
    import moment from 'moment-timezone';
    import time_utils from '../../mixins/time_utils';
    import Swal from 'sweetalert2';
    import {EventBus} from '../../eventBus/nav-bar-event'
    export default {
        mixins: [facility_mgmt, time_utils],
        components: {
            SweetModal,
            AddNewReportSchedule,
            Swal
        },
        data() {
            return {
                delete_loader: false,
                addreportmodal: false,
                mode: 'create',
                list_data: [],
                skip: 0,
                limit: 10,
                total: 0,
                temp_total: 0,
                search_key: '',
                pageLimit: [],
                skip_temp: 0,
                count: 0,
                pageLimit: [],
                selected_id: '',
                schedule_name: '',
                email_ids: '',
                description: '',
                schedule_time: '',
                shift_name: '',
                data_loader: false,
                ajax_call_in_progress: false,
            }
        },
        methods: {
            moment(date) {
                return moment(date);
            },
            saveSuccess() {
                this.fetchListData();
            },
            CreateReportScheduleModal() {
                EventBus.$emit('ZindexChangeStart')
                this.mode = 'create'
                this.addreportmodal = true
                setTimeout(() => {
                    this.$modal.show('CreateNewReportModal')
                }, 500)
            },
            showEditModal() {
                EventBus.$emit('ZindexChangeStart')
                this.mode = 'edit';
                this.addreportmodal = true
                setTimeout(() => {
                    this.$modal.show('CreateNewReportModal')
                }, 500)
            },
            HideAddScheduleModal() {
                EventBus.$emit('ZindexChangeEnd')
                this.addreportmodal = false
            },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.fetchListData()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.fetchListData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.fetchListData();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.fetchListData();
            },
            deleteScheduleConfirm(id) {
                Swal.fire({
                    title: 'Alert',
                    text: "Are you sure want to delete ?",
                    type: 'warning',
                    icon: 'warning',
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonColor: '#00448b',
                    confirmButtonText: 'YES',
                    cancelButtonText: 'NO'
                }).then((result) => {
                    if (result.isConfirmed == true) {
                        this.deleteSchedule(id)
                    }
                })
            },
            async deleteSchedule(id) {
                this.delete_loader = true
                try {
                    let params = {
                        report_schedule_id: [this.selected_id],
                    }
                    let response = await this.deleteReportScheduleById(params);
                    this.success_msg = response.response.success_message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.delete_loader = false
                        this.$refs.success_modal.close();
                        this.fetchListData();
                    }, 3000);
                } catch (error) {
                    this.delete_loader = false
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            async fetchListData() {
                this.list_data = [];
                this.ajax_call_in_progress = true;
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit,
                        search_key: this.search_key.trim(),
                    };
                    let response = await this.getReportScheduleList(params);
                    this.list_data = response.response.report_schedule;
                    if(response.response.report_schedule !=0){
                    this.selected_id = this.list_data[0]._id;
                    this.fetchDataById(this.selected_id);
                }
                    this.total = response.response.count;
                    this.ajax_call_in_progress = false;
                } catch (error) {
                    this.list_data = [];
                    this.ajax_call_in_progress = false;
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
            async fetchDataById(id) {
                this.selected_id = id
                this.data_loader = true
                try {
                    let params = {
                        report_schedule_id: this.selected_id
                    };
                    let response = await this.getReportScheduleById(params);
                    this.schedule_name = response.response.schedule_name;
                    this.email_ids = response.response.email_id.join(', ') || '';
                    this.description = response.response.description || '';
                    this.schedule_time = response.response.report_schedule.schedule_time.replace(/_/g, ' ');
                    if (response.response.report_schedule.shiftwise) {
                        this.shift_name = {
                            shift_name: response.response.report_schedule.shiftwise
                        }
                    }
                    // this.report_date = response.response.report_schedule.start_date_time.start_date;
                    // this.report_time = response.response.report_schedule.start_date_time.start_time ? this.convertTime24To12(response.response.report_schedule.start_date_time.start_time) : '';
                    // this.recurrence = response.response.report_schedule.recurrence ? response.response.report_schedule.recurrence.replace(/_/g, ' ') : '';
                    // this.start_date = response.response.report_schedule.start_date_time.start_date;
                    // this.start_time = response.response.report_schedule.start_date_time.start_time ? this.convertTime24To12(response.response.report_schedule.start_date_time.start_time) : '';
                    // this.end_date = response.response.report_schedule.end_date_time ? response.response.report_schedule.end_date_time.end_date : '';
                    // this.end_time = response.response.report_schedule.end_date_time ? this.convertTime24To12(response.response.report_schedule.end_date_time.end_time) : '';
                    this.data_loader = false
                } catch (error) {
                    this.data_loader = false
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                }
            },
        },
        mounted() {
            for (let i = 10; i <= 50; i += 10) {
                this.pageLimit.push(i);
            }
            this.fetchListData();
        },
        watch: {
            limit: function () {
                this.fetchListData();
            }
        },
        computed: {
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        }
    }
</script>

<style scoped>

    .btn-shift {
        border: 2px solid #038b62 !important;
        background: white;
        border-radius: 5px;
        color: #038b62;
    }

    .list-text {
        font-size: 17px;
        font-weight: 500;
        color: #000;
    }

    .list-text-count {
        font-size: 16px;
        font-weight: 00;
        font-weight: 600;
        color: rgba(54, 54, 54, 0.61);
    }

    table td {
        text-align: left;
    }

    .ht-100px {
        height: 100px
    }
    .btn-new-call {
        background-color: #03855d !important;
        color: white;
        border-radius: 5px;
    }
    .list-light {
        width: 100%;
        object-fit: contain;
        border-radius: 5px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        border: solid 0.5px #f3f6fb;
        background-color: #ffffff;
    }
    .highlight {
        background-color: #d5e2fa !important;
    }

    @media (max-width: 1100px) {
        .hide-line {
            display: none;
        }
    }

    .edit-button {
        background-color: #fff;
        height: 32px !important;
        width: 40px;
        line-height: 39px !important;
        border-radius: 4px;
    }

    .box-blue-header {
        border-radius: 3px;
    }

    .box-blue-header-parent {
        background: #005dae;
        position: relative;
        top: -1px;
        margin-left: -1px;
    }

    .ticket_count {
        background-color: #7b7f97;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .count-ticket {
        background-color: #1b57ad;
        border-radius: 20px;
        font-size: 10px;
        font-weight: 600 !important;
        color: #ffffff;
        margin-left: 4px;
        padding: 0px 6px;
    }

    .ticket_tab {
        background-color: #005dae;
    }

    .activeColor {
        background-color: #005dae;
        color: #ffffff;
    }

    .email-buttons {
        display: none;
    }

    @media screen and (max-width: 991px) {
        .mob-list-scroll {
            min-width: 991px;
        }
    }

    .btn-success {
        background-color: #25bb83 !important;
    }

    .ticket-list-button {
        color: #363636;
        border-radius: 6px !important;
        box-shadow: none !important;
        font-weight: 600;
        background-color: #e4e4e4;
        width: 230px;
    }
    .scm-filters {
        font-family: "Poppins", "Helvetica Neue", sans-serif !important;
        height: 500px;
        overflow: auto;
        max-width: 768px;
        top: 100px;
        background: #e6ecff !important;
    }

    .overflow-visible {
        overflow: scroll !important;
    }
    .col-small-left {
        width: 200px;
    }

    .col-small-right {
        position: relative;
        width: 700px;
    }

    .left-list {
        height: max-content !important;
    }

    @media (max-width: 900px) {
        .scroll-news {
            min-width: 900px;
            overflow-x: scroll !important;
        }
    }

    @media (max-width: 580px) {
        .vendor-list {
            height: 100% !important;
        }
    }

    .hor-line {
        width: 2px;
        height: 30px;
        background-color: #1b57ad;
    }

    .filter-box {
        width: 200px;
        height: 30px;
        padding: 2px 3.3px 1.5px 6.5px;
        border: solid 0.5px #363636;
        background-color: #fff;
    }

    .width-fit-content {
        width: fit-content
    }

    .fs-18 {
        font-size: 18px;
    }

    .whitespace-nowrap {
        white-space: nowrap;
    }

    .dropbtn {
        background-color: #fff;
        cursor: pointer;
        margin-top: -5px;
        border-radius: 5px;
        line-height: 33px;
    }

    .res-width {
        min-width: 60%
    }

    .ticket_list_number-selected {
        background-color: #00448b !important;
        color: #fff !important;
    }

    .ticket_list_number-selected .li_span {
        color: #fff !important
    }

    .ticket_list_number-selected i {
        color: #fff !important;
        border: 1px solid #fff !important;
    }

    .ticket_list_number-selected i.no-border {
        border: none !important;
    }

    @media screen and (max-width:1347px) {
        .res-width {
            min-width: 75%
        }
    }

    @media screen and (max-width:1011px) {
        .res-width {
            min-width: 100%;
            flex-wrap: wrap
        }
    }


    .dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #fff;
        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        z-index: 1;
        right: 0px;
        top: 32px;
    }

    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed {
        width: 100%;
        vertical-align: middle;
    }

    .dropdown-content a:not([href]):not([tabindex]).tabbed:hover {
        background-color: #eee;
    }

    .dropdown:hover .dropdown-content {
        display: block;
    }

    .height-fit-content {
        height: fit-content
    }

    .search_input {
        padding: 8px 9.4px 6.5px 33.4px;
        border-radius: 24px;
        background-color: #fff;
        border: 1px solid rgba(103, 103, 103, 0.84);
        border-radius: 18px;
    }

    .align-position {
        position: absolute;
        left: 10px;
        top: 7px;
        color: rgba(103, 103, 103, 0.84);
    }

    .search-bar {
        margin: 0 30px 0 30px;
    }

    .add-btn {
        margin-right: 24px;
        height: 34px;
    }

    .ht-100px {
        height: 100px;
    }

    .w-15 {
        width: 15% !important
    }

    .w-1 {
        width: 1% !important;
        min-width: 250px !important
    }

    .table-content-data tr th {
        text-transform: capitalize;
        color: #00448b;
        background-color: #e8e9ec;
    }

    .text-white {
        color: #fff !important;
    }

    .text-green {
        color: #038b62 !important;
    }

    .breadcrumbnewtheme {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    .breadcrumbnewtheme div {
        color: #00448b;
    }
    .fs-2rem {
        font-size: 2rem;
    }

    .position-content-main {
        border-radius: 14px;
        background-color: #f0ddb7;
    }

    .header-color {
        color: #4e4e4e !important;
    }
</style>